import "../Promotions.css";
import React, { useEffect, useState } from "react";

import CommunityServices from "../api/CommunityServices";
import CopyLinkModal from "./ModelComponents/CopyLinkModal";
import HorizontalScroll from "./CommonComponents/HorizontalScroll/HorizontalScroll";
import WorkoutModal from "./ModelComponents/CommunityDetail/WorkoutModal";
import EventServices from "../api/Event/PostServices";
import WorkoutDesc from "./ModelComponents/CommunityDetail/WorkoutDesc";

const Promotions = ({ handleShowPromotions }) => {
  const [loading, setLoading] = useState(false);
  const [communityWorkouts, setCommunityWorkouts] = useState([]);
  const [shareId, setShareId] = useState(null);
  const [shareLink, setShareLink] = useState("");
  const [showModal, setshowModal] = useState(false);
  const [showDescModal, setshowDescModal] = useState(false);
  const [selectedWorkout, setSelectedWorkout] = useState(null);

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Delay showing the component by 15 seconds
    const timer = setTimeout(() => {
      setIsVisible(true);
      getCommunitieProgramsList();
    }, 15000);

    return () => clearTimeout(timer); // Cleanup on unmount
  }, []);

  useEffect(() => {
    getCommunitieProgramsList();
  }, []);

  const getCommunitieProgramsList = async () => {
    setLoading(true);
    try {
      const result = await CommunityServices.getFeaturedPromotedContent();
      if (result?.status === 200) {
        setCommunityWorkouts(result?.data?.data?.programs?.data);
      } else {
        console.log(result?.data?.message, { autoClose: 1000 });
      }
    } catch (error) {
      console.log(error?.result?.data?.errors[0], { autoClose: 2000 });
    }
    setLoading(false);
  };

  const getShareLink = async (id) => {
    setLoading(true);
    try {
      const result = await EventServices.createSharedLink(
        `type=program&actual_id=${id}`
      );
      if (result?.status === 200) {
        setShareLink(result?.data);
        setshowModal(true);
      } else {
        console.log(result?.data?.message, { autoClose: 1000 });
      }
    } catch (error) {
      console.log(error?.result?.data?.errors[0], { autoClose: 2000 });
    }
    setLoading(false);
  };

  const handleShowModal = (workout) => {
    setShareId(workout?.id);
    getShareLink(workout?.id);
  };

  const handleShowDescModal = (workout) => {
    setSelectedWorkout(workout);
    setshowDescModal(true);
  };

  if (!isVisible) return null;

  return communityWorkouts?.length > 0 ? (
    <div className="promotion-modal-overlay community-workouts-section">
      {console.log("promotions")}
      {showModal && (
        <CopyLinkModal
          shareId={shareId}
          setShareId={setShareId}
          setshowModal={setshowModal}
          page={"program"}
          link={shareLink}
        />
      )}

      {showDescModal && (
        <WorkoutDesc
          setshowModal={setshowDescModal}
          workout={selectedWorkout}
        />
      )}

      <div className="promotions-modal upcoming-scroll-data my-4 d-flex flex-column justify-start">
        <div className="d-flex flex-row justify-content-end align-items-start">
          <span className="close" onClick={handleShowPromotions}>
            <i className="fa fa-times close-icon"></i>
          </span>
        </div>
        <p className="upcoming-title">
          Exclusive Workouts from Communities & Experts
        </p>
        <span className="sub-title">
          Transform Your Body with Premium Workout Plans
        </span>
        {communityWorkouts?.length > 0 ? (
          <div className="container my-2">
            <HorizontalScroll
              component={communityWorkouts?.map((work) => (
                <div key={work.id} className="p-3">
                  <WorkoutModal
                    key={work.id}
                    workout={work}
                    handleShowModal={handleShowModal}
                    handleSowDescModal={handleShowDescModal}
                  />
                </div>
              ))}
            />
          </div>
        ) : (
          <div className="no-upcomming-data my-2">No Record Found</div>
        )}
      </div>
    </div>
  ) : null;
};

export default Promotions;
